export default "__VITE_ASSET__619f7f10__"